import { PaymentMethodConditions } from '@nemuru-eng/checkout-js';

import { LoanConditions as LoanConditionsType } from '@/components/modules/Application/components/PaymentMethod/_shared/types/LoanConditions';
import { SetupFeeEntity } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/entities/SetupFeeEntity';

export const LoanConditionsMap = {
  toLoanConditions: (paymentMethodConditions: PaymentMethodConditions[]): LoanConditionsType[] => {
    return paymentMethodConditions.map((option) => {
      if (!option.conditions) {
        throw new Error('No conditions available for Loan payment method');
      }
      if (!option.conditions.lenderName) {
        throw new Error('No lender name available for Loan payment method');
      }
      if (!option.conditions.pricingId) {
        throw new Error('No pricing ID available for Loan payment method');
      }
      return {
        instalmentTotalAmount: option.conditions.instalmentTotalAmount,
        apr: option.conditions.apr,
        providerName: option.conditions.lenderName,
        pricingId: option.conditions.pricingId,
        principal: option.amount,
        annualInterest: option.conditions.annualInterest,
        term: option.conditions.term,
        setupFeeType: option.conditions.setupFeeType,
        setupFee: SetupFeeEntity.create({
          term: option.conditions.term,
          currency: option.currency,
          setupFeeAmount: option.conditions.setupFeeAmount?.value,
          setupFeeType: option.conditions.setupFeeType,
          amount: option.amount.value,
        }).relative,
        gracePeriod: option.conditions.gracePeriod,
        gracePercentage: option.conditions.gracePercentage,
        totalAmount: option.conditions.totalAmount,
      };
    });
  },
};
